import { createAction } from '@reduxjs/toolkit';

export const clearNetworkSettingsForm = createAction('CLEAR_NETWORK_SETTINGS_FORM');
